<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>日报管理</el-breadcrumb-item>
      <el-breadcrumb-item>日报列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <div class="filter">
        <el-form
          label-position="right"
          class="search-form"
          label-width="90px"
          inline
          size="small"
          @submit.native.prevent
        >
          <el-form-item label="项目">
            <ProjectSelect v-model="filter.project_id"></ProjectSelect>
          </el-form-item>
          <el-form-item label="上报人">
            <UserSelect v-model="filter.user_id"></UserSelect>
          </el-form-item>
          <el-form-item label="钻头序列号">
            <el-input
              size="small"
              v-model="filter.drill_number"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属日期" prop="date">
            <el-date-picker
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div style="margin-left: 80px">
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              getData(false)
            "
            >筛选</el-button
          >
          <el-button size="small" @click="getData(true)">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel">
      <ListTable :list="list"></ListTable>
      <el-pagination
        background
        class="m-t-20 text-right"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @current-change="getData(false)"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { reportList } from '../../../service/getData'
import ProjectSelect from '../../../components/select/project_select.vue'
import UserSelect from '../../../components/select/user_select.vue'
import ListTable from './_table.vue'
export default {
  components: {
    ListTable,
    ProjectSelect,
    UserSelect,
  },
  data() {
    return {
      filter: {
        page: 1,
        size: 10,
        project_id: '',
        user_id: '',
        date: '',
        drill_number: '',
      },
      total: 0,
      list: [],
    }
  },
  created() {
    if (this.$route.query.project_id) {
      this.filter.project_id = parseInt(this.$route.query.project_id)
    }
    if (this.$route.query.user_id) {
      this.filter.user_id = parseInt(this.$route.query.user_id)
    }
    if (this.$route.query.drill_number) {
      this.filter.drill_number = this.$route.query.drill_number
    }
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.project_id = ''
        this.filter.user_id = ''
        this.filter.date = ''
        this.filter.drill_number = ''
      }
      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let params = this.clone(this.filter)
      params.page -= 1
      if (params.date && params.date.length == 2) {
        params.date_start = params.date[0]
        params.date_end = params.date[1]
      }
      let res = await reportList(params)
      this.list = res.data.list
      this.total = res.data.count
    },
  },
}
</script>